(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-list"] && !Shopify.designMode) return;
  try {
    
  class MaterialsTabs extends HTMLElement {
    constructor() {
      super();
      this.triggers = [];
      this.panels = [];
    }

    connectedCallback() {
      this.triggers = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      if (this.triggers.length === 0) return;

      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', this.handleClick.bind(this));
        trigger.addEventListener('keydown', this.handleKeydown.bind(this));
      });
    }

    handleClick(event) {
      const trigger = event.currentTarget;
      this.activate(trigger);
    }

    handleKeydown(event) {
      const currentIndex = this.triggers.indexOf(event.currentTarget);
      let nextIndex = null;

      switch (event.key) {
        case 'ArrowDown':
        case 'ArrowRight':
          nextIndex = (currentIndex + 1) % this.triggers.length;
          break;
        case 'ArrowUp':
        case 'ArrowLeft':
          nextIndex = (currentIndex - 1 + this.triggers.length) % this.triggers.length;
          break;
        case 'Home':
          nextIndex = 0;
          break;
        case 'End':
          nextIndex = this.triggers.length - 1;
          break;
        default:
          return;
      }

      event.preventDefault();
      const nextTrigger = this.triggers[nextIndex];
      this.activate(nextTrigger);
      nextTrigger.focus();
    }

    activate(activeTrigger) {
      const activeIndex = activeTrigger.dataset.tabIndex;

      this.triggers.forEach((trigger) => {
        const isActive = trigger === activeTrigger;
        trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
        trigger.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      this.panels.forEach((panel) => {
        const isActive = panel.dataset.tabIndex === activeIndex;
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }
  }

  if (!customElements.get('materials-tabs')) {
    customElements.define('materials-tabs', MaterialsTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
